"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "syncedBrandingSettings", {
  enumerable: true,
  get: function get() {
    return _syncedBrandingSettings["default"];
  }
});
var _syncedBrandingSettings = _interopRequireDefault(require("./syncedBrandingSettings"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }